/**
 * Bármilyen stringből csinál snake-case-t.
 * @example
 * toSnake-case → to_snake_case
 * @param {string} str - A string, amit átalakítunk.
 * @returns {string} Az átalakított szöveg.
 */
module.exports.toSnakeCase = function toSnakeCase (str) {
  if (!str.trim()) {
    return ''
  }

  return str
    .trim()
    .replace(/([0-9a-záéíóöúüőű])([A-ZÁÉÍÓÖÚÜŐŰ])/g, '$1_$2')
    .replace(/[\s-]+/g, '_')
    .replace(/^[-_]+|[-_]+$/g, '')
    .toLowerCase()
}
